import ADataTableBody from './index.vue';

ADataTableBody.install = app => {
  app.component(ADataTableBody.name, ADataTableBody);
};

export default ADataTableBody;
